import { baseService } from "../base";

export interface ProjectNote {
  id: string;
  projectId: string;
  bookingId?: string;
  serviceTicketId?: string;
  content: string;
  noteType: 'general' | 'operational' | 'client' | 'internal';
  isPinned: boolean;
  authorId?: string;
  author?: {
    id: string;
    firstName: string;
    lastName: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateProjectNoteDto {
  projectId: string;
  bookingId?: string;
  serviceTicketId?: string;
  content: string;
  noteType?: 'general' | 'operational' | 'client' | 'internal';
  isPinned?: boolean;
}

export interface UpdateProjectNoteDto extends Partial<CreateProjectNoteDto> {}

export interface GetProjectNotesParams {
  projectId?: string;
  bookingId?: string;
  serviceTicketId?: string;
  noteType?: string;
  isPinned?: boolean;
  page?: number;
  pageSize?: number;
}

export const getProjectNotes = async (params?: GetProjectNotesParams) => {
  const response = await baseService.get("/project-notes", { params });
  return response.data;
};

export const getProjectNote = async (id: string) => {
  const response = await baseService.get(`/project-notes/${id}`);
  return response.data;
};

export const createProjectNote = async (data: CreateProjectNoteDto) => {
  const response = await baseService.post("/project-notes", data);
  return response.data;
};

export const updateProjectNote = async (id: string, data: UpdateProjectNoteDto) => {
  const response = await baseService.patch(`/project-notes/${id}`, data);
  return response.data;
};

export const toggleProjectNotePin = async (id: string) => {
  const response = await baseService.patch(`/project-notes/${id}/toggle-pin`);
  return response.data;
};

export const deleteProjectNote = async (id: string) => {
  const response = await baseService.delete(`/project-notes/${id}`);
  return response.data;
};
